import * as types from './actionTypes';
import { getRequest } from '../../lib/apiUtils';

export function getRecipientSuggestions(name, otherInput = {}, blackList = []) {
    return async dispatch => {
        dispatch({ type: types.START_GET_RECIPIENT_SUGGESTIONS });

        let addressInfo = otherInput.address ? { streetNumber: otherInput.address.streetNumber, street: otherInput.address.street, city: otherInput.address.city, state: otherInput.address.state } : {};
        delete otherInput.address;

        const response = await getRequest('/recipients/suggestions', { name, ...otherInput, ...addressInfo }, []);
        if(blackList.length) {
            response.data = response.data.filter(rec => blackList.indexOf(rec.applicantId) < 0);
        }

        dispatch({ type: types.GET_RECIPIENT_SUGGESTIONS, response });
    };
}

export function clearRecipientSuggestions() {
    return dispatch => {
        dispatch({ type: types.CLEAR_RECIPIENT_SUGGESTIONS });
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/SuggestionsActions.js